import Notificaciones from "./Notificaciones";

export default Notificaciones;
